import Factory from './factory';

export default new Factory()
    .addProp('options', Array)
    .addProp('required', Boolean)
	.addPassthrough('options')
    .addPassthrough('required');
